import { render } from "./charts-dashboard.view.vue?vue&type=template&id=65591f68&scoped=true&ts=true"
import script from "./charts-dashboard.view.vue?vue&type=script&lang=ts"
export * from "./charts-dashboard.view.vue?vue&type=script&lang=ts"

import "./charts-dashboard.view.vue?vue&type=style&index=0&id=65591f68&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65591f68"]])

export default __exports__